/* tslint:disable */
/* eslint-disable */
/**
 * Default API
 * All endpoints not defined under specific APIs
 *
 * The version of the OpenAPI document: Latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
import { Forecast, ForecastFromJSON, ForecastToJSON } from "./";

/**
 *
 * @export
 * @interface ForecastResult
 */
export interface ForecastResult {
  state: string;
  /**
   *
   * @type {Array<Forecast>}
   * @memberof ForecastResult
   */
  conversionForecasts?: Array<Forecast>;
  /**
   *
   * @type {Array<Forecast>}
   * @memberof ForecastResult
   */
  forecasts?: Array<Forecast>;
  /**
   *
   * @type {Array<string>}
   * @memberof ForecastResult
   */
  unknownPackageCodes: Array<string>;
  /**
   *
   * @type {boolean}
   * @memberof ForecastResult
   */
  regioChannelForecastNotAvailable?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ForecastResult
   */
  regioPackageForecastNotAvailable?: boolean;
}

export function ForecastResultFromJSON(json: any): ForecastResult {
  return ForecastResultFromJSONTyped(json, false);
}

export function ForecastResultFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ForecastResult {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    conversionForecasts: !exists(json, "conversionForecasts")
      ? undefined
      : (json["conversionForecasts"] as Array<any>).map(ForecastFromJSON),
    forecasts: !exists(json, "forecasts")
      ? undefined
      : (json["forecasts"] as Array<any>).map(ForecastFromJSON),
    unknownPackageCodes: json["unknownPackageCodes"],
    regioChannelForecastNotAvailable: !exists(
      json,
      "regioChannelForecastNotAvailable",
    )
      ? undefined
      : json["regioChannelForecastNotAvailable"],
    regioPackageForecastNotAvailable: !exists(
      json,
      "regioPackageForecastNotAvailable",
    )
      ? undefined
      : json["regioPackageForecastNotAvailable"],
    state: "",
  };
}

export function ForecastResultToJSON(value?: ForecastResult | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    conversionForecasts:
      value.conversionForecasts === undefined
        ? undefined
        : (value.conversionForecasts as Array<any>).map(ForecastToJSON),
    forecasts:
      value.forecasts === undefined
        ? undefined
        : (value.forecasts as Array<any>).map(ForecastToJSON),
    unknownPackageCodes: value.unknownPackageCodes,
    regioChannelForecastNotAvailable: value.regioChannelForecastNotAvailable,
    regioPackageForecastNotAvailable: value.regioPackageForecastNotAvailable,
  };
}
